import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../axiosInterceptor';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const EmailSetting = () => {
    // const [settingData, setSettingData] = useState([]);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState({
        email: '',
        password: '',
        host: '',
        port: '',
        fromEmail: '',
        bccEmail: '',
        ccEmail: '',
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`emailsetting/getEmailSetting`);
            const { data } = response.data;
            // setSettingData(data);
            setData({ ...data });
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
        setData({ ...data, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!data.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(data.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!data.password?.trim()) newErrors.password = "Password is required";
        if (!data.host?.trim()) newErrors.host = "Host is required";
        if (!data.port) newErrors.port = "Port is required";

        if (data.fromEmail && !emailRegex.test(data.fromEmail)) newErrors.fromEmail = "Invalid email format";
        if (data.bccEmail && !emailRegex.test(data.bccEmail)) newErrors.bccEmail = "Invalid email format";
        if (data.ccEmail && !emailRegex.test(data.ccEmail)) newErrors.ccEmail = "Invalid email format";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        const newData = { ...data };
        if (newData._id) {
            delete newData._id;
            delete newData.createdAt
            delete newData.updatedAt
            delete newData.__v
        }
        try {
            const response = await axiosInstance.put(`emailsetting/updateEmailSetting`, newData);
            if (response.status === 200) {
                toast.success(response.data.message);
                fetchData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <div className="content-wrapper">
            <div className="page-header mt-5 mx-4">
                <h3 className="page-title">Email Configuration </h3>
            </div>
            <div className="col-md-12 grid-margin stretch-card">
                <div className="col-md-8  ">
                    <div className="card">
                        <div className="card-body">
                            <form className="pt-3" onSubmit={handleUpdate}>
                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        Email
                                    </label>
                                    <div className="col-sm-9">
                                        <input
                                            type="email"
                                            className={`form-control form-control-sm ${errors.email ? "border-danger" : ""}`}
                                            id="email"
                                            name="email"
                                            placeholder="Enter email"
                                            value={data.email || ''}
                                            onChange={handleChange}
                                        />
                                        {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        Password
                                    </label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className={`form-control form-control-sm ${errors.password ? "border-danger" : ""}`}
                                                id="password"
                                                name="password"
                                                placeholder="Enter password"
                                                value={data.password || ''}
                                                onChange={handleChange}
                                            />
                                            <span className="input-group-text" onClick={togglePasswordVisibility} style={{
                                                height: "41px",
                                            }}>
                                                {showPassword ? <FaEye className='fs-2' /> : <FaEyeSlash className='fs-2' />}
                                            </span>
                                        </div>
                                        {errors.password && <div className="text-danger small mt-1">{errors.password}</div>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        Host
                                    </label>
                                    <div className="col-sm-9">
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${errors.host ? "border-danger" : ""}`}
                                            id="host"
                                            name="host"
                                            placeholder="Enter host"
                                            value={data.host || ''}
                                            onChange={handleChange}
                                        />
                                        {errors.host && <div className="text-danger small mt-1">{errors.host}</div>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        Port
                                    </label>
                                    <div className="col-sm-9">
                                        <input
                                            type="number"
                                            className={`form-control form-control-sm ${errors.port ? "border-danger" : ""}`}
                                            id="port"
                                            name="port"
                                            placeholder="Enter port"
                                            value={data.port || ''}
                                            onChange={handleChange}
                                        />
                                        {errors.port && <div className="text-danger small mt-1">{errors.port}</div>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        From Email
                                    </label>
                                    <div className="col-sm-9">
                                        <input
                                            type="email"
                                            className={`form-control form-control-sm ${errors.fromEmail ? "border-danger" : ""}`}
                                            id="fromEmail"
                                            name="fromEmail"
                                            placeholder="Enter fromEmail"
                                            value={data.fromEmail || ''}
                                            onChange={handleChange}
                                        />
                                        {errors.fromEmail && <div className="text-danger small mt-1">{errors.fromEmail}</div>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        Bcc Email
                                    </label>
                                    <div className="col-sm-9">
                                        <input
                                            type="email"
                                            className={`form-control form-control-sm ${errors.bccEmail ? "border-danger" : ""}`}
                                            id="bccEmail"
                                            name="bccEmail"
                                            placeholder="Enter bccEmail"
                                            value={data.bccEmail || ''}
                                            onChange={handleChange}
                                        />
                                        {errors.bccEmail && <div className="text-danger small mt-1">{errors.bccEmail}</div>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label
                                        htmlFor="exampleInputUsername2"
                                        className="col-sm-3 col-form-label"
                                    >
                                        Cc Email
                                    </label>
                                    <div className="col-sm-9">
                                        <input
                                            type="email"
                                            className={`form-control form-control-sm ${errors.ccEmail ? "border-danger" : ""}`}
                                            id="ccEmail"
                                            name="ccEmail"
                                            placeholder="Enter ccEmail"
                                            value={data.ccEmail || ''}
                                            onChange={handleChange}
                                        />
                                        {errors.ccEmail && <div className="text-danger small mt-1">{errors.ccEmail}</div>}
                                    </div>
                                </div>
                                <div className='text-center'>
                                    <Link to="/dashboard"><button className="btn btn-secondary mr-2">
                                        Back </button></Link>
                                    <button type="submit" className="btn btn-success">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailSetting